type Props =
  | 'Available'
  | 'Preparing'
  | 'Charging'
  | 'SuspendedEV'
  | 'Suspended_evse'
  | 'Finishing'
  | 'Reserved'
  | 'Faulted'
  | 'Unavailable'
  | 'Maintenance';

type GetConnectorStatus = (
  props: Props,
  availabilityReason?: string | null,
) => 'available' | 'unavailable' | 'busy' | 'maintenance' | 'faulted' | 'groupFull';

export const getConnectorStatus: GetConnectorStatus = (status, availabilityReason) => {
  // MV2-1997: Unavailable causado pelo bloqueio do smart charging
  if (status === 'Unavailable' && availabilityReason === 'SMARTCHARGING_LIMIT') {
    return 'groupFull';
  }
  switch (status) {
    case 'Charging':
    case 'Finishing':
    case 'Suspended_evse':
    case 'SuspendedEV':
    case 'Reserved':
    case 'Preparing':
      return 'busy';
    case 'Faulted':
      return 'faulted';
    case 'Unavailable':
      return 'unavailable';
    case 'Available':
      return 'available';
    case 'Maintenance':
      return 'maintenance';
    default:
      return 'unavailable';
  }
};
